import React, { useRef, useEffect } from 'react'
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import banner from "../../Assests/images/home_images/home-banner.jpg"
import mobileBanner from "../../Assests/images/home_images/mobile-home-banner.jpg"
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Head = () => {
    const headRef = useRef(null);
    useEffect(() => {
        if (window.location.hash === '#head') {
            headRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);
    return (
        <header className="banner">
            <LazyLoadImage
                src={banner}
                alt="Desktop Banner Image"
                className="banner-image h-100 desktop-banner"
                style={{ filter: 'brightness(0.6)' }} 
            />
            <LazyLoadImage
                src={mobileBanner}
                alt="Mobile Banner Image"
                className="banner-image h-100 mobile-banner"
                style={{ filter: 'brightness(0.6)' }} 
            />
            <div className="banner-text w-100">
                <div className="heading-title d-flex flex-column gap-5">
                    <h1 className="title text-white text-center mb-4 ">Real Estate Ownership for Everyone</h1>
                    <div>
                        <p className='title text-white text-center mb-4 h3'>Affordable Real Estate Investment Made Easy!</p>
                        <p className="h6 fw-4 text-white text-center mb-4">India's Trusted Platform for Smart Fractional Ownership and Real Estate Investment</p>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Head;

// {/* <div className="wg-filter">
//                                 <div className="form-title">
//                                     <div className="tf-dropdown-sort " data-bs-toggle="dropdown">
//                                         <div className="btn-select">
//                                             <span className="text-sort-value">For sale</span><i className="icon-CaretDown"></i>
//                                         </div>
//                                         <div className="dropdown-menu">
//                                             <div className="select-item active">
//                                                 <span className="text-value-item">For sale</span>
//                                             </div>
//                                             <div className="select-item">
//                                                 <span className="text-value-item">For rent</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <form>
//                                         <fieldset>
//                                             <input type="text" placeholder="Place, neighborhood, school or agent..." />
//                                         </fieldset>
//                                     </form>
//                                     <div className="box-item wrap-btn">
//                                         <div className="btn-filter show-form">
//                                         <div className="icons" onClick={toggleDivs} style={{ cursor: "pointer" }}>
//                                                         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                             <path d="M21 4H14" stroke="#F1913D" strokeWidth="2" strokeLinecap="round" strokeLinecap="round"></path>
//                                                             <path d="M10 4H3" stroke="#F1913D" strokeWidth="2" strokeLinecap="round" strokeLinecap="round"></path>
//                                                             <path d="M21 12H12" stroke="#F1913D" strokeWidth="2" strokeLinecap="round" strokeLinecap="round"></path>
//                                                             <path d="M8 12H3" stroke="#F1913D" strokeWidth="2" strokeLinecap="round" strokeLinecap="round"></path>
//                                                             <path d="M21 20H16" stroke="#F1913D" strokeWidth="2" strokeLinecap="round" strokeLinecap="round"></path>
//                                                             <path d="M12 20H3" stroke="#F1913D" strokeWidth="2" strokeLinecap="round" strokeLinecap="round"></path>
//                                                             <path d="M14 2V6" stroke="#F1913D" strokeWidth="2" strokeLinecap="round" strokeLinecap="round"></path>
//                                                             <path d="M8 10V14" stroke="#F1913D" strokeWidth="2" strokeLinecap="round" strokeLinecap="round"></path>
//                                                             <path d="M16 18V22" stroke="#F1913D" strokeWidth="2" strokeLinecap="round" strokeLinecap="round"></path>
//                                                         </svg>
//                                              </div>
//                                         </div>
//                                         <a href="#" className="tf-btn bg-color-primary pd-3">
//                                             Search <i className="icon-MagnifyingGlass fw-6"></i>
//                                         </a>
//                                     </div>
//                                 </div>
//                                 <div className="wd-search-form">
//                                     <div className="group-price">
//                                         <div className="widget-price">
//                                             <div className="box-title-price">
//                                                 <span className="title-price">Price range</span>
//                                                 <div className="caption-price">
//                                                     <span>from</span>
//                                                     <span className="value fw-6" id="slider-range-value1"></span>
//                                                     <span>to</span>
//                                                     <span className="value fw-6" id="slider-range-value2"></span>
//                                                 </div>
//                                             </div>
//                                             <div id="slider-range"></div>
//                                             <div className="slider-labels">
//                                                 <div>
//                                                     <input type="hidden" name="min-value" value="" ></input>
//                                                     <input type="hidden" name="max-value" value=""></input>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="widget-price">
//                                             <div className="box-title-price">
//                                                 <span className="title-price">Size range</span>
//                                                 <div className="caption-price">
//                                                     <span>from</span>
//                                                     <span className="value fw-6" id="slider-range-value01"></span>
//                                                     <span>to</span>
//                                                     <span className="value fw-6" id="slider-range-value02"></span>
//                                                 </div>
//                                             </div>
//                                             <div id="slider-range2"></div>
//                                             <div className="slider-labels">
//                                                 <div>
//                                                     <input type="hidden" name="min-value2" value=""></input>
//                                                     <input type="hidden" name="max-value2" value=""></input>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className=" group-select">
//                                         <div className="box-select">
//                                             <div className="nice-select" tabIndex="0">
//                                                 <span className="current">Province / States</span>
//                                                 <ul className="list">
//                                                     <li data-value="1" className="option">California</li>
//                                                     <li data-value="2" className="option selected">Texas</li>
//                                                     <li data-value="3" className="option">Florida </li>
//                                                     <li data-value="4" className="option">New York
//                                                     </li>
//                                                     <li data-value="5" className="option">Illinois</li>
//                                                     <li data-value="6" className="option">Washington</li>
//                                                     <li data-value="7" className="option">Pennsylvania</li>
//                                                     <li data-value="8" className="option">Ohio</li>
//                                                     <li data-value="9" className="option">Georgia</li>
//                                                     <li data-value="10" className="option">North Carolina
//                                                     </li>
//                                                 </ul>
//                                             </div>
//                                         </div>
//                                         <div className="box-select">
//                                             <div className="nice-select" tabIndex="0">
//                                                 <span className="current">Rooms</span>
//                                                 <ul className="list">
//                                                     <li data-value="1" className="option">1</li>
//                                                     <li data-value="2" className="option selected">2</li>
//                                                     <li data-value="3" className="option">3</li>
//                                                     <li data-value="4" className="option">4</li>
//                                                     <li data-value="5" className="option">5</li>
//                                                     <li data-value="6" className="option">6</li>
//                                                     <li data-value="7" className="option">7</li>
//                                                     <li data-value="8" className="option">8</li>
//                                                     <li data-value="9" className="option">9</li>
//                                                     <li data-value="10" className="option">10</li>
//                                                 </ul>
//                                             </div>
//                                         </div>
//                                         <div className="box-select">
//                                             <div className="nice-select" tabIndex="0">
//                                                 <span className="current">Bath: Any</span>
//                                                 <ul className="list">
//                                                     <li data-value="1" className="option">1</li>
//                                                     <li data-value="2" className="option selected">2</li>
//                                                     <li data-value="3" className="option">3</li>
//                                                     <li data-value="4" className="option">4</li>
//                                                 </ul>
//                                             </div>
//                                         </div>
//                                         <div className="box-select">
//                                             <div className="nice-select" tabIndex="0">
//                                                 <span className="current">Beds: Any</span>
//                                                 <ul className="list">
//                                                     <li data-value="1" className="option">1</li>
//                                                     <li data-value="2" className="option selected">2</li>
//                                                     <li data-value="3" className="option">3</li>
//                                                     <li data-value="4" className="option">4</li>
//                                                     <li data-value="5" className="option">5</li>
//                                                     <li data-value="6" className="option">6</li>
//                                                 </ul>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="group-checkbox">
//                                         <div className=" title text-4 fw-6">Amenities:</div>
//                                         <div className="group-amenities ">
//                                             <fieldset className="checkbox-item style-1  ">
//                                                 <label>
//                                                     <span className="text-4">Bed linens</span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4"> Carbon alarm</span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4">Check-in lockbox </span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4">Coffee maker </span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>


//                                             <fieldset className="checkbox-item style-1  ">
//                                                 <label>
//                                                     <span className="text-4"> Dishwasher</span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4"> Fireplace</span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4">Extra pillows </span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4">First aid kit </span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>

//                                             <fieldset className="checkbox-item style-1  ">
//                                                 <label>
//                                                     <span className="text-4">Hangers </span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4">Iron</span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4"> Microwave</span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4">Fireplace</span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>

//                                             <fieldset className="checkbox-item style-1  ">
//                                                 <label>
//                                                     <span className="text-4"> Refrigerator</span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4">Security cameras </span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4"> Smoke alarm</span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                             <fieldset className="checkbox-item style-1   mt-12">
//                                                 <label>
//                                                     <span className="text-4">Fireplace </span>
//                                                     <input type="checkbox" />
//                                                     <span className="btn-checkbox"></span>
//                                                 </label>
//                                             </fieldset>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div> */}
// {/* </div>
//                     </div>
//                 </div>
//             </div> */}
// {/* {isOpen && (
//         <div className="wd-search-form show mx-auto pt-5 mt-5">
//         <div className="toggle-content">
//           <div className="group-price">
        
//         <div className="widget-price">
//             <div className="box-title-price">
//                 <span className="title-price">Price range</span>
//                 <div className="caption-price">
//                     <span>from</span>
//                     <span className="value fw-6">${priceRange[0]}</span>
//                     <span>to</span>
//                     <span className="value fw-6">${priceRange[1]}</span>
//                 </div>
//             </div>
//             <ReactSlider
//         className="slider"
//         thumbClassName="thumb"
//         trackClassName="track"
//         value={priceRange}
//         min={0}
//         max={1000}
//         step={10}
//         onChange={setPriceRange}
//         pearling
//         minDistance={50}
//         renderTrack={(props, state) => (
//           <div
//             {...props}
//             className={`track ${state.index === 1 ? "track-active" : "track-inactive"}`}
//           />
//         )}
//       />
//         </div>

       
//         <div className="widget-price">
//             <div className="box-title-price">
//                 <span className="title-price">Size range</span>
//                 <div className="caption-price">
//                     <span>from</span>
//                     <span className="value fw-6">{sizeRange[0]} sqft</span>
//                     <span>to</span>
//                     <span className="value fw-6">{sizeRange[1]} sqft</span>
//                 </div>
//             </div>
//             <ReactSlider
//           className="slider"
//           thumbClassName="thumb"
//           trackClassName="track"
//           value={sizeRange}
//           min={500}
//           max={5000}
//           step={100}
//           onChange={(value) => setSizeRange(value)}
//           pearling
//           minDistance={200}
//           renderTrack={(props, state) => (
//             <div
//               {...props}
//               className={`track ${state.index === 1 ? "track-active" : "track-inactive"}`}
//             />
//           )}
//         />
//         </div>
//     </div>

// <div className="group-checkbox">
//         <div className="title text-4 fw-6">Amenities:</div>
//         <div className="group-amenities">
//             {amenitiesList.map((amenity, index) => (
//                 <fieldset className="checkbox-item style-1 mt-11 " key={index}>
//                     <label>
//                         <span className="text-4">{amenity}</span>
//                         <input
//                             type="checkbox"
//                             checked={selectedAmenities.includes(amenity)}
//                             onChange={() => handleCheckboxChange(amenity)}
//                         />
//                         <span className="btn-checkbox"></span>
//                     </label>
//                 </fieldset>
//             ))}
//         </div>
//     </div>
//     <div className="group-select pt-5"> 
       
//         <div className="box-select">
//             <select className="nice-select" value={province} onChange={(e) => setProvince(e.target.value)}>
//                 <option value="California">California</option>
//                 <option value="Texas">Texas</option>
//                 <option value="Florida">Florida</option>
//                 <option value="New York">New York</option>
//                 <option value="Illinois">Illinois</option>
//                 <option value="Washington">Washington</option>
//                 <option value="Pennsylvania">Pennsylvania</option>
//                 <option value="Ohio">Ohio</option>
//                 <option value="Georgia">Georgia</option>
//                 <option value="North Carolina">North Carolina</option>
//             </select>
//         </div>

        
//         <div className="box-select">
//             <select className="nice-select" value={rooms} onChange={(e) => setRooms(e.target.value)}>
//                 {[...Array(10).keys()].map((num) => (
//                     <option key={num + 1} value={num + 1}>{num + 1}</option>
//                 ))}
//             </select>
//         </div>

       
//         <div className="box-select">
//             <select className="nice-select" value={baths} onChange={(e) => setBaths(e.target.value)}>
//                 {[1, 2, 3, 4].map((num) => (
//                     <option key={num} value={num}>{num}</option>
//                 ))}
//             </select>
//         </div>

        
//         <div className="box-select">
//             <select className="nice-select" value={beds} onChange={(e) => setBeds(e.target.value)}>
//                 {[1, 2, 3, 4, 5, 6].map((num) => (
//                     <option key={num} value={num}>{num}</option>
//                 ))}
//             </select>
//         </div>
//     </div>
//         </div>
//         </div>
//       )} */}

// {/* </div>
//   )
// }

// export default Head */}